export enum CollectDrawingsStatusEnum {
  NotStarted = 0,
  Started = 1,
  Completed = 2,
  Failed = 3,
  CompletedConfirmed = 4,
  FailedConfirmed = 5,
}
